import { PhysicalAddress as PhysicalAddressProto } from '@taxfyle/api-internal/shared/types/physical_address_pb'
import type { PhysicalAddress } from './PhysicalAddress'

export function mapPhysicalAddressProtoToProps(
  proto: PhysicalAddressProto,
): PhysicalAddress {
  return {
    addressLine1: proto.getAddressLine1(),
    addressLine2: proto.getAddressLine2(),
    city: proto.getCity(),
    region: proto.getRegion(),
    postalCode: proto.getPostalCode(),
    country: proto.getCountry(),
  }
}

export function mapPhysicalAddressToProto(
  physicalAddress: PhysicalAddress,
): PhysicalAddressProto {
  return new PhysicalAddressProto()
    .setAddressLine1(physicalAddress.addressLine1)
    .setAddressLine2(physicalAddress.addressLine2)
    .setCity(physicalAddress.city)
    .setRegion(physicalAddress.region)
    .setPostalCode(physicalAddress.postalCode)
    .setCountry(physicalAddress.country)
}
